import {Presenter} from '../../../support/with_presenter';
import {Chapter} from '../../../models/Chapter';

export interface ChapterDeleter {
    delete(chapter: Chapter): void;
}

export class ChapterInsertPresenter implements Presenter {
    constructor(private chapterInteractor: ChapterDeleter) {}

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public onTrashChapter(chapter: Chapter) {
        this.chapterInteractor.delete(chapter);
    }
}
